export default "__VITE_ASSET__e05c644b__"